import React from 'react';
import '../styles/FieldCapacityNotification.css';

const FieldCapacityNotification = ({ 
  validation, 
  onReduceTeams, 
  onIncreaseFields, 
  onProceedAnyway,
  onDismiss 
}) => {
  if (!validation.hasInsufficientFields) {
    return null;
  }

  const { 
    requiredFields, 
    availableFields, 
    teamsPlayingPerRound, 
    teamsWaitingPerRound,
    matchesPerTeamMin,
    matchesPerTeamMax,
    teamsWithExtraMatch
  } = validation;

  return (
    <div className="field-capacity-notification">
      <div className="notification-header">
        <h4>⚠️ Nicht genügend Felder verfügbar</h4>
        <button className="dismiss-btn" onClick={onDismiss} aria-label="Schließen">×</button>
      </div>
      
      <div className="notification-content">
        <p className="warning-message">
          Für {validation.maxSimultaneousMatches} gleichzeitige Spiele werden <strong>{requiredFields} Felder</strong> benötigt, 
          aber nur <strong>{availableFields} Felder</strong> sind verfügbar.
        </p>
        
        <div className="impact-details">
          <h5>Auswirkungen:</h5>
          <ul>
            <li>Pro Runde spielen nur <strong>{teamsPlayingPerRound} Teams</strong></li>
            <li><strong>{teamsWaitingPerRound} Teams</strong> müssen pro Runde warten</li>
            <li>Spieler haben <strong>{matchesPerTeamMin}
              {teamsWithExtraMatch > 0 ? `-${matchesPerTeamMax}` : ''} Spiele</strong> 
              {teamsWithExtraMatch > 0 && ` (${teamsWithExtraMatch} Teams bekommen ein zusätzliches Spiel)`}
            </li>
          </ul>
        </div>
          <div className="suggestions">
          <h5>Empfohlene Lösungen:</h5>
          <div className="suggestion-buttons">
            <button 
              className="suggestion-btn primary" 
              onClick={onReduceTeams}
              title="Reduziert die Teamanzahl und generiert automatisch ein neues Turnier"
            >
              Teams reduzieren & Turnier erstellen
            </button>
            
            <button 
              className="suggestion-btn primary" 
              onClick={onIncreaseFields}
              title="Erhöht die Feldanzahl und generiert automatisch ein neues Turnier"
            >
              Felder erhöhen & Turnier erstellen
            </button>
            
            <button 
              className="suggestion-btn secondary" 
              onClick={onProceedAnyway}
              title="Verwendet verbesserten Algorithmus für gleichmäßige Spielverteilung"
            >
              Trotzdem fortfahren (optimierte Verteilung)
            </button>
          </div>
        </div>
        
        <div className="algorithm-info">
          <p className="info-note">
            💡 Bei "Trotzdem fortfahren" wird ein optimierter Algorithmus verwendet, 
            der die Spiele möglichst gleichmäßig auf alle Spieler verteilt.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FieldCapacityNotification;
